import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import ParagraphsWithColumns from "@modules/ParagraphsWithColumns"

const OurCommitments = () => {
  const { t } = useTranslation()
  const params = {
    theme: "white-bg",
    className:
      "pt-0 pb-6 md:py-10 md:px-11 -mt-6 md:mt-0 desk:px-25 desk:py-20",
    paragraphs: [
      {
        text: t("CaseStudyCompetitive_Paragraph1"),
      },
      {
        text: t("CaseStudyCompetitive_Paragraph2"),
      },
    ],
    gridClassName:
      "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-[74px] xl:gap-[178px] desk:max-w-[100%] desk:justify-center max-w-[622px] xl:max-w-[1574px]",
  }
  return <ParagraphsWithColumns {...params} />
}

export default OurCommitments
